(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ma-email-reward"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';
  var node = document.getElementById('ma-email-reward-config');
  if (!node) return;
  var config = JSON.parse(node.textContent);
  var root = document.documentElement;
  var state = { active: root.hasAttribute('data-ma-email-reward'), status: 'checking', remaining: 0 };
  var lastCart = null;
  var version = 0;
  var queued = false;
  var endpoint = config.root + 'cart.js';
  var claimUrl = config.root + 'discount/' + encodeURIComponent(config.code) + '?redirect=' + encodeURIComponent(config.root + 'pages/claim-credit');

  function readSaved() {
    try {
      var value = JSON.parse(localStorage.getItem(config.storageKey) || 'null');
      return !!value && value.code === config.code && value.expires === config.expires && Date.now() < config.expires;
    } catch (e) { return false; }
  }
  function remember() {
    try { localStorage.setItem(config.storageKey, JSON.stringify({ code: config.code, expires: config.expires })); } catch (e) {}
  }
  function forget() {
    try { localStorage.removeItem(config.storageKey); } catch (e) {}
  }
  function classify(cart) {
    if (Date.now() >= config.expires) return { active: false, status: 'ended', remaining: 0 };
    if (Date.now() < config.starts) return { active: false, status: 'upcoming', remaining: 0 };
    var match = cart && Array.isArray(cart.discount_codes) && cart.discount_codes.find(function (entry) {
      return String(entry.code || '').toUpperCase() === config.code;
    });
    if (match) remember();
    var active = !!match || readSaved();
    if (!active) return { active: false, status: 'no-code', remaining: 0 };
    if (!cart) return { active: true, status: 'checking', remaining: 0 };
    if (!match) return { active: true, status: 'remembered', remaining: 0 };
    if (match.applicable === true) return { active: true, status: 'applied', remaining: 0 };
    var items = cart.items || [];
    if (!items.length) return { active: true, status: 'saved', remaining: 0 };
    var eligible = items.some(function (item) { return !item.gift_card; });
    if (!eligible) return { active: true, status: 'unavailable', remaining: 0 };
    var subtotal = items.reduce(function (sum, item) { return sum + Number(item.final_line_price || 0); }, 0);
    if (cart.currency === 'USD' && subtotal < config.minimum) {
      return { active: true, status: 'pending', remaining: config.minimum - subtotal };
    }
    return { active: true, status: 'unavailable', remaining: 0 };
  }
  function textFor(status) {
    var text = config.text[status] || config.text.checking;
    if (status === 'pending') {
      var money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: 'USD' }).format(state.remaining / 100);
      text = text.replace('[remaining]', money);
    }
    return text;
  }
  function putText(el, text) { if (el && el.textContent !== text) el.textContent = text; }
  function show(el, visible) { if (el && el.hidden === visible) el.hidden = !visible; }
  function render() {
    root.toggleAttribute('data-ma-email-reward', state.active);
    root.dataset.maRewardState = state.status;
    document.querySelectorAll('[data-ma-reward-surface]').forEach(function (el) {
      show(el, state.active);
      var copy = el.dataset.maRewardSurface === 'banner' && state.status !== 'applied' ? config.text.banner : state.status === 'pending' && el.dataset.maRewardSurface === 'pdp' ? config.text.qualifying : textFor(state.status);
      putText(el.querySelector('[data-ma-reward-copy]'), copy);
      var link = el.querySelector('[data-ma-reward-claim]');
      if (link) { link.href = claimUrl; show(link, state.status === 'remembered'); }
    });
    document.querySelectorAll('[data-claim]').forEach(function (el) {
      var current = state.status;
      var mapped = current === 'unavailable' ? 'blocked' : ['pending', 'remembered', 'checking'].indexOf(current) >= 0 ? 'saved' : current;
      if (!state.active && mapped !== 'ended' && mapped !== 'upcoming') mapped = 'no-code';
      el.dataset.state = mapped;
      el.querySelectorAll('[data-for]').forEach(function (part) { show(part, part.dataset.for === mapped); });
      var message = el.querySelector('[data-for="' + mapped + '"] .ma-claim__intro p');
      if (state.active && message) putText(message, textFor(current));
      var outside = mapped === 'ended' || mapped === 'upcoming';
      show(el.querySelector('[data-btn="ghost"]'), outside);
      var main = el.querySelector('[data-btn="main"]');
      show(main, !outside);
      if (main) {
        main.href = current === 'remembered' ? claimUrl : config.root;
        putText(main, current === 'remembered' ? config.text.claim : config.text.shop);
      }
    });
  }
  function update(cart) {
    lastCart = cart;
    state = classify(cart);
    if (state.status === 'ended') forget();
    render();
  }
  function refresh() {
    var request = ++version;
    if (state.active) { state = { active: true, status: 'checking', remaining: 0 }; render(); }
    return fetch(endpoint, { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (response) { if (!response.ok) throw new Error('Cart unavailable'); return response.json(); })
      .then(function (cart) { if (request === version) update(cart); })
      .catch(function () { if (request === version) update(null); });
  }
  function scheduleRender() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; render(); });
  }
  document.addEventListener('cart:change', function (event) {
    var cart = event.detail && event.detail.cart;
    if (cart && Array.isArray(cart.items) && Array.isArray(cart.discount_codes)) { ++version; update(cart); }
    else refresh();
  });
  document.addEventListener('cart:refresh', refresh);
  window.addEventListener('pageshow', function (event) { if (event.persisted) refresh(); });
  window.addEventListener('storage', function (event) { if (event.key === config.storageKey) refresh(); });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') refresh(); });
  new MutationObserver(scheduleRender).observe(document.body, { childList: true, subtree: true });
  setInterval(function () { if (Date.now() >= config.expires && state.status !== 'ended') update(lastCart); }, 30000);
  if (config.initialApplied && Date.now() < config.expires) remember();
  update(null);
  refresh();
})();
  } catch(e) { console.error(e); }
})();

})();
